package com.tedd.db

import kotlin.Long
import kotlin.String

public data class SelectDueReset(
  public val id: String,
  public val name: String,
  public val description: String?,
  public val status: String,
  public val date: String?,
  public val recurrence: String,
  public val next_reset_date: String,
  public val last_reset_date: String?,
  public val reset_mode: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
